import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * BeeImagePreview, used to display image/s in a modal. When multiple images, carousel mode is enabled.
 * Used in BeeFileUploader.
 *
 * @example
 *
 * matDialog.open(BeeImagePreviewComponent, {
 *    width: '800px',
 *    minWidth: '320px',
 *    data: {
 *      imagePreviews: this.imagePreviews,
 *      selectedImageIndex: i
 *    }
 * });
 */
@Component({
  selector: 'bee-image-preview',
  templateUrl: 'bee-image-preview.component.html',
  styleUrls: ['./bee-image-preview.component.scss'],
})
export class BeeImagePreviewComponent {
  /**
   * Title of the modal.
   * @type {string}
   */
  title = 'Visor de imágenes';
  /**
   * List of the image's url.
   * @type {string[]}
   */
  imagePreviews: string [] = [];
  /**
   * Initial selected image.
   * @type {number}
   */
  selectedImageIndex = 0;

  /**
   * Constructor.
   * @param dialogRef The dialog Reference.
   * @param data The dialog Data.
   */
  constructor(private dialogRef: MatDialogRef<BeeImagePreviewComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.imagePreviews = data.imagePreviews;
    if (this.imagePreviews.length > 0) {
      this.selectedImageIndex = data.selectedImageIndex;
    }
    if (data.title) {
      this.title = data.title;
    }
  }

  /**
   * Select the previous image of the carousel.
   */
  previousImage() {
    if (this.selectedImageIndex === 0) {
      this.selectedImageIndex = this.imagePreviews.length - 1;
    } else {
      this.selectedImageIndex--;
    }
  }

  /**
   * Select the next image of the carousel.
   */
  nextImage() {
    if (this.selectedImageIndex === this.imagePreviews.length - 1) {
      this.selectedImageIndex = 0;
    } else {
      this.selectedImageIndex++;
    }
  }

  /**
   * KeyDown event, used to manage left and right arrows.
   * @param $event
   */
  onKeyDown($event: KeyboardEvent) {
    if ($event.key === 'ArrowRight') {
      this.nextImage();
    } else if ($event.key === 'ArrowLeft') {
      this.previousImage();
    }
  }

  /**
   * Closes the dialog.
   */
  closeDialog(): void {
    this.dialogRef.close();
  }
}
